import { Container, Row, Col } from "react-bootstrap";
import { useState } from "react";
import logo from '../assets/img/Base.gif';
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";
import navIcon4 from "../assets/img/nav-icon4.svg";

export const Footer = () => {
    const [tooltipText, setTooltipText] = useState('Copy to clipboard');

    const copyToClipboard = (mail) => {
        navigator.clipboard.writeText(mail)
            .then(() => {
                setTooltipText('Copied...');
                setTimeout(function() {
                    setTooltipText('Copy to clipboard');
                }, 2000);
            })
            .catch((error) => {
                console.error('Error copying to clipboard: ', error);
            });
    }
    return (
        <footer id="footer" className="footer">
            <Container>
                <Row className="align-items-center">
                    <Col size={12} sm={6}>
                        <img className="footer-logo" src={logo} alt="Logo" />
                    </Col>
                    <Col size={12} sm={6} className="text-center text-sm-end">
                        <div className="social-icon">
                            <a target="_blank" href="https://www.tiktok.com/@arcaunity"><img src={navIcon1} alt="TikTok" /></a>
                            <a target="_blank" href="https://www.facebook.com/people/Arca-Unity/100093599084781/" rel="noopener noreferrer"><img src={navIcon2} alt="Facebook" /></a>
                            <a target="_blank" href="https://www.instagram.com/arcaunity/" rel="noopener noreferrer"><img src={navIcon3} alt="Instagram" /></a>
                            <a target="_blank" href="https://www.youtube.com/@ArcaUnity" rel="noopener noreferrer"><img src={navIcon4} alt="Youtube" /></a>
                        </div>
                        <p>Contact Us: <span className="tooltipmail" onClick={() => copyToClipboard('arcaunitycommunity@gmail.com')}>
                            <a className="mail">arcaunitycommunity@gmail.com</a>
                            <span className="tooltiptext">{tooltipText}</span>
                        </span></p>
                        <p>Copyright 2023. All Rights Reserved</p>
                    </Col>
                </Row>
            </Container>
        </footer>
    )
}